import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _TransactionGetter = Getter.of();
export const _TransactionResponseGetter = Getter.of();
export const _TransactionsGetter = Getter.of();
export const _TransactionsResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _TransactionsResponse2Transactions = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _TransactionResponse2Transaction = _Response2ResponseData();
export const _Transaction2Attributes = Fold.compose(_TransactionGetter, Res._Response(), Lens.prop("attributes"));
export const _TransactionAttributes2Status = Fold.compose(_Transaction2Attributes, Lens.prop("status"));
export const _TransactionAttributes2Type = Fold.compose(_Transaction2Attributes, Lens.prop("type"));
export const _TransactionAttributes2Amount = Fold.compose(_Transaction2Attributes, Lens.prop("amount"));
export const _TransactionAttributes2Currency = Fold.compose(_Transaction2Attributes, Lens.prop("currency"));
export const _TransactionAttributes2MaskedCardNumber = Fold.compose(_Transaction2Attributes, Lens.prop("maskedCardNumber"));
export const _TransactionAttributes2Period = Fold.compose(_Transaction2Attributes, Lens.prop("period"));
export const _TransactionAttributes2ProductDescription = Fold.compose(_Transaction2Attributes, Lens.prop("productDescription"));
export const _TransactionAttributes2ProductName = Fold.compose(_Transaction2Attributes, Lens.prop("productName"));
export const _TransactionAttributes2Created = Fold.compose(_Transaction2Attributes, Lens.prop("created"));
export const _TransactionAttributes2Updated = Fold.compose(_Transaction2Attributes, Lens.prop("updated"));
export const _Transaction2PaymentMethod = Fold.compose(_TransactionGetter, Res._Rel("paymentMethod"));
export const _Transaction2PricePlan = Fold.compose(_TransactionGetter, Res._Rel("pricePlan"));
export const _Transaction2Subscription = Fold.compose(_TransactionGetter, Res._Rel("subscription"));
export const _Transaction2TaxRecord = Fold.compose(_TransactionGetter, Res._Rel("taxRecord"));

